import { Button } from '@/components/ui/button';
import { saveResultsModules } from '@/utils/saveResultsModules';
import { useState } from 'react';

function Questionnaire({ feedbackType, onValidate, sessionId, role } : { feedbackType: string, onValidate: () => void, sessionId: string, role: string }) {
  const [value, setValue] = useState(5);

  const handleSubmit = () => {
    // console.log(`Feedback submitted for ${feedbackType}: ${value}`);
    onValidate(); // Call the callback to move to the next module
    saveResultsModules(
      [{ field: feedbackType, value: JSON.stringify(value) }],
      sessionId,
      role
    );
  };

  // Fonction pour obtenir la couleur selon la valeur
  const getColorByValue = (val: number) => {
    if (val <= 3) return '#ef4444'; // Rouge pour difficile
    if (val <= 7) return '#f59e0b'; // Orange pour moyen
    return '#10b981'; // Vert pour facile
  };

  // Fonction pour obtenir le texte selon la valeur
  const getTextByValue = (val: number) => {
    if (val <= 2) return 'Très difficile';
    if (val <= 4) return 'Difficile';
    if (val <= 6) return 'Moyen';
    if (val <= 8) return 'Facile';
    return 'Très facile';
  };

  return (
    <div className="bg-black text-white min-h-screen flex flex-col justify-center items-center p-8">
      <div className="bg-gray-900 rounded-lg p-8 shadow-2xl border border-gray-700 max-w-md w-full">
        <h2 className="text-2xl font-bold text-center mb-8 text-white">
          Évaluation de la difficulté
        </h2>
        
        <div className="space-y-6">
          {/* <label htmlFor="facilite" className="block text-lg font-medium text-center text-gray-200">
            J'ai trouvé l'exercice facile :
          </label> */}
          
          {/* Indicateur visuel de facilité */}
          <div className="text-center">
            <div 
              className="inline-block px-6 py-3 rounded-full text-xl font-bold transition-all duration-300"
              style={{ 
                backgroundColor: getColorByValue(value),
                color: 'white',
                boxShadow: `0 0 20px ${getColorByValue(value)}40`
              }}
            >
              {value}/10 - {getTextByValue(value)}
            </div>
          </div>

          {/* Slider personnalisé */}
          <div className="px-4">
            <input
              id="facilite"
              type="range"
              min="0"
              max="10"
              value={value}
              onChange={(e) => setValue(parseInt(e.target.value, 10))}
              className="w-full h-3 bg-gray-700 rounded-lg appearance-none cursor-pointer"
              style={{
                background: `linear-gradient(to right, #ef4444 0%, #f59e0b 50%, #10b981 100%)`,
              }}
            />
            
            {/* Échelle numérique */}
            <div className="flex justify-between text-sm text-gray-400 mt-2">
              <span>0</span>
              <span>2</span>
              <span>4</span>
              <span>6</span>
              <span>8</span>
              <span>10</span>
            </div>
            
            {/* Labels des extrêmes */}
            <div className="flex justify-between text-sm text-gray-300 mt-1">
              <span>Très difficile</span>
              <span>Très facile</span>
            </div>
          </div>
        </div>

        <Button 
          onClick={handleSubmit} 
          className="w-full mt-8 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200"
        >
          Valider mon évaluation
        </Button>
      </div>
    </div>
  );
}

export default Questionnaire;
